// 文件相关接口
import request from '@/utils/request'
import { FileEntity } from './fileEntity';

export const fileApi = {
  // 创建文件
  createFile: (data: FileEntity) =>
    request.post<FileEntity>('/admin/file', data),

  // 更新文件
  updateFile: (data: FileEntity) =>
    request.put<FileEntity>('/admin/file', data),

  // 删除文件
  deleteFile: (id: number) =>
    request.delete(`/admin/file/${id}`),

  // 根据 standardId 查询文件
  getFilesByStandardId: (standardId: number) =>
    request.get<FileEntity>('/admin/file/standardId', {
      params: { standardId }
    })
};